import { render } from "./AiTestReport.vue?vue&type=template&id=cf198a96&scoped=true&ts=true"
import script from "./AiTestReport.vue?vue&type=script&lang=ts"
export * from "./AiTestReport.vue?vue&type=script&lang=ts"

import "./AiTestReport.vue?vue&type=style&index=0&id=cf198a96&scoped=true&lang=css"
import "./AiTestReport.vue?vue&type=style&index=1&id=cf198a96&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf198a96"]])

export default __exports__